
/*
 * *********************************************
 * BRANDING
 * ********************************************
 */
export const brandingQueryKeys = {
  all: ['branding'] as const,
};
